import { Close } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";

interface RemoveCustomerDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  customerEmail: string;
  loading: boolean;
}

const RemoveCustomerDialog: React.FC<RemoveCustomerDialogProps> = ({
  open,
  onClose,
  onConfirm,
  customerEmail,
  loading,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Remove Customer
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to remove <strong>{customerEmail}</strong> from
          this whitelabel? They will no longer appear in your customer list.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
        >
          {loading ? "Removing..." : "Remove"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveCustomerDialog;
